import { render } from "./VehicleEnergyGraph.vue?vue&type=template&id=67565140"
import script from "./VehicleEnergyGraph.vue?vue&type=script&lang=js"
export * from "./VehicleEnergyGraph.vue?vue&type=script&lang=js"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__